import React from "react";
import { connect } from "react-redux";
import HomeBanner from "components/banners/HomeBanner";
import Card from "components/card";


const HomeScreen = () => {
  
  return (
    <div className="m-4 flex flex-col h-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">      
      <HomeBanner/>

      <Card extra="p-10 max-w-[300px] lg:max-w-[800px]">
        <h1 className="text-[28px] font-bold text-center mb-5">Track, Certify, and Protect Your Livestock Lineage</h1>
        <p className="text-[18px]">Welcome to <span className="font-bold">Bakode Cert</span>, the smart way to manage your farm animals’ pedigree.
From birth records to bloodline history, every detail is stored securely and instantly accessible through QR tag scanning.</p>

        <div className="mt-8">
          <a className="btn btn-primary text-[22px] text-center font-black home-drop-shadow" href="/auth/sign-in">
              Start Managing
          </a>
        </div>
      </Card>

      
      
    </div>
  );
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({  
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeScreen);